import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';
import useRacesWithResults from '../useRacesWithResults.tsx';

const useLeaderboardLink = (): NavLinkProps | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event, lastSelectedRace }] = useApp();
  const { uniqueCode, subEvents = [] } = event || {};
  const racesWithResults = useRacesWithResults();
  const { search } = useLocation();
  const { isLeaderboard } = useAppLocation();
  const derivedUrl = useMemo(() => {
    const raceId = lastSelectedRace ? lastSelectedRace : `${racesWithResults[0]?.id}`;
    return `/events/${uniqueCode}/race/${encodeURIComponent(raceId)}${search}`;
  }, [uniqueCode, racesWithResults, search, lastSelectedRace]);

  if (!event || subEvents.length === 0 || racesWithResults.length === 0) {
    return null;
  }

  return {
    id: 'leaderboard',
    active: isLeaderboard,
    children: (
      <Link
        to={derivedUrl}
        className={'flex items-center'}
        data-dd-action-name={'link-leaderboard-nav_menu'}>
        <List size={16} strokeWidth={2} className={'mr-4'} />
        {t('leaderboard_label')}
      </Link>
    ),
  };
};

export default useLeaderboardLink;
